import {polyfill} from 'es6-promise';
polyfill();
import 'babel-polyfill';
